import { createPrefixer } from '.'

const ROOT = 'ver-importaciones' as const

export const RESOURCE_IMPORTACIONES = 'Importaciones PG' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')

/**
 * Arbol de permisos de Importaciones
 */
const permission = {
    _root: ROOT,
    _resource: RESOURCE_IMPORTACIONES,
    transacciones: {
        _perm: rp('transacciones'),
        gestionRequerimiento: pt('gestion-requerimiento'),
        bandejaGastoImportacion: pt('bandeja-gasto-importacion'),
        gastoImportacion: pt('gasto-importacion'),
        bandejaAprobacion: pt('bandeja-aprobacion'),
        crearRequerimiento: pt('crear-requerimiento'),
        nacionalizacionImportacion: pt('nacionalizacion-importacion'),
        bandejaDistribucionImportacion: pt('bandeja-distribucion-importacion'),
        distribucionImportacion: pt('distribucion-importacion'),
        cierreImportacion: pt('cierre-importacion'),
        gestionLiquidacion: pt('gestion-liquidacion'),
        liquidacionImportacion: pt('liquidacion-importacion'),
        aprobacionLiquidacion: pt('aprobacion-liquidacion'),
        asignacionGastoImportacion: pt('asignacion-gasto-importacion'),
        bandejaPendienteNacionalizar: pt('bandeja-pendiente-nacionalizar'),
        recepcionImportacion: pt('recepcion-importacion'),
        revisionliquidacion: pt('revision-liquidacion'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        nivelesAprobacion: pc('niveles-aprobacion'),
        incoterms: pc('incoterms'),
    },
    mantenimiento: {
        _perm: rp('mantenimiento'),
        crearImpuesto: pm('crear-impuesto'),
        gestionImpuestos: pm('gestion-impuestos'),
        crearPartidaArancelaria: pm('crear-partida-arancelaria'),
        crearRegimenAduanero: pm('crear-regimen-aduanero'),
        gestionRegimenesAduaneros: pm('gestion-regimenes-aduaneros'),
        gestionDivisas: pm('gestion-divisas'),
    },
    informes: {
        _perm: rp('informes'),
        requerimientoImportaciones: pi('requerimiento-importaciones'),
        resumenLiquidacionesGastos: pi('resumen-liquidaciones-gastos'),
        derechoArancelarios: pi('derecho-arancelarios'),
    },
}
export default permission
